import { api } from './api';
import { ApiResponse } from '../types/api';
import { HelpItem, HelpReorderRequest } from '../types/help';

export const helpService = {
  // 관리자용: 전체 목록 (숨김 포함)
  getAllItems: async (): Promise<HelpItem[]> => {
    const res = await api.get<ApiResponse<HelpItem[]>>('/api/admin/help');
    return res.data.data;
  },

  // 항목 추가
  createItem: async (data: Omit<HelpItem, 'id' | 'createdDt' | 'updatedDt'>): Promise<void> => {
    await api.post('/api/admin/help', data);
  },

  // 항목 수정
  updateItem: async (id: number, data: Omit<HelpItem, 'id' | 'createdDt' | 'updatedDt'>): Promise<void> => {
    await api.put(`/api/admin/help/${id}`, data);
  },

  // 항목 삭제
  deleteItem: async (id: number): Promise<void> => {
    await api.delete(`/api/admin/help/${id}`);
  },

  // 순서 일괄 저장 (드래그앤드랍)
  reorder: async (requests: HelpReorderRequest[]): Promise<void> => {
    await api.put('/api/admin/help/reorder', requests);
  },
};
